<template>
  <div
    ref="containerHistory"
    class="col full-height q-px-md q-pt-xs"
  >
    <div
      v-if="isLoadingHistory"
      class="column items-center justify-center full-height tw-gap-2"
    >
      <q-spinner-ios
        color="primary"
        size="2.5em"
      />
      <span class="tw-text-xs tw-text-muted-foreground">Carregando histórico...</span>
    </div>

    <div
      v-else-if="!history.length"
      class="column items-center justify-center full-height tw-gap-1"
    >
      <q-icon
        name="mdi-history"
        size="28px"
        color="blue-grey-4"
      />
      <span class="tw-text-xs tw-text-muted-foreground">Nenhum atendimento anterior deste contato</span>
    </div>

    <q-virtual-scroll
      v-else
      ref="scrollhistory"
      :style="`height: ${heightArea}px; max-height: ${heightArea}px`"
      :items="history"
      :virtual-scroll-slice-size="12"
      :virtual-scroll-item-size="72"
      @virtual-scroll="onScroll"
    >
      <template #default="{ item }">
        <ContactHistoryItem
          :attendance="item"
        />
      </template>
    </q-virtual-scroll>
  </div>
</template>

<script>
import { dom } from 'quasar'
import { mapActions } from 'vuex'
import moment from 'moment-timezone'
import ContactHistoryItem from './ContactHistoryItem'
export default {
  components: {
    ContactHistoryItem
  },

  props: {
    attendance: {}
  },

  data () {
    return {
      heightArea: 0
    }
  },

  mounted () {
    const vm = this
    vm.mounted = true
    vm.timeout = null
    vm.resizeObserver = new ResizeObserver(vm.recalcArea)
    vm.resizeObserver.observe(vm.$refs.containerHistory.parentNode)
    vm.recalcArea()
  },

  beforeDestroy () {
    const vm = this
    if (vm.timeout) clearTimeout(vm.timeout)
    vm.resizeObserver = null
    vm.mounted = false
  },

  computed: {
    isLoadingHistory () {
      return !Array.isArray(this.attendance?.history)
    },

    isOngoing () {
      return ['ONGOING', 'CONNECTED'].includes(this.attendance.status)
    },

    loadMore () {
      return this.attendance.hasMoreHistory && this.isOngoing
    },

    history () {
      const vm = this
      const attendances = Array.isArray(vm.attendance.history) ? vm.attendance.history : []
      return attendances.filter((item) => Number(item.attendanceId) !== Number(vm.attendance.id))
    }
  },

  methods: {
    ...mapActions({
      loadHistory: 'attendanceModule/loadHistory'
    }),

    dateFormated (attendance) {
      const dateTimestamp = attendance.chatsCreatedAt ?? attendance.callsCreatedAt
      return moment.unix(dateTimestamp).format('DD-MM-YYYY HH:MM')
    },

    onScroll (props) {
      const qtByPage = 15
      const countHistory = this.attendance?.history?.length ?? 0
      const page = countHistory / qtByPage + 1
      const lastIndex = props.index === countHistory - 1
      if (this.loadMore && lastIndex) this.loadHistory({ ...this.attendance, page })
    },

    recalcArea () {
      const vm = this
      if (!vm.mounted) return

      try {
        if (!vm.$refs.containerHistory) return
        const heightArea = dom.height(vm.$refs.containerHistory)
        if (this.timeout) clearTimeout(this.timeout)

        if (!heightArea) {
          this.timeout = setTimeout(() => vm.recalcArea(), 300)
          return
        }

        if (heightArea !== vm.heightArea) vm.heightArea = heightArea
      } catch (error) {
        console.log({ error })
      }
    }
  }
}

</script>

<style lang="sass">
  .card-history
    path
      fill: #0277BD
  .card-item
    border: 1px solid #1769B6
    border-radius: 8px
    .q-card
      border-radius: 8px

  .virtualScroll::-webkit-scrollbar
    display: none

</style>
